// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMobileV1SendMessageRequest,
  TPublicMobileV1SendMessageModel,
  IMappers,
  TPublicMobileV1SendMessageResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISendMessageResponse } from '../../../entities/send_message/SendMessageResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMobileV1SendMessageModel(
  parameters: TPublicMobileV1SendMessageRequest,
): TPublicMobileV1SendMessageModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/mobile/v1/send-message/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicMobileV1SendMessageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicMobileV1SendMessageRequest;
}

export async function fetchPublicMobileV1SendMessage<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMobileV1SendMessageOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMobileV1SendMessageResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMobileV1SendMessageModel(parameters),
    config,
  )) as FetchResponse<TPublicMobileV1SendMessageResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendMessageResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMobileV1SendMessageResponse>;
}
